import { render, staticRenderFns } from "./EditExerciseMissingCharacter.vue?vue&type=template&id=13498226&"
import script from "./EditExerciseMissingCharacter.vue?vue&type=script&lang=ts&"
export * from "./EditExerciseMissingCharacter.vue?vue&type=script&lang=ts&"
import style0 from "./EditExerciseMissingCharacter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports